import type { NotAttachedNote } from "../../lib/vendorInvoiceApi";

/**
 * D185.5 — the one wording for why a bill did not attach itself to its order's PO, chosen by code (invariant 6);
 * null when there is nothing for the person to settle (no order, not confirmed, already on a PO, an expense, removed by hand).
 */
export function notAttachedMessage(note?: NotAttachedNote | null): string | null {
  const supplier = note?.vendorName || "this supplier";
  switch (note?.code) {
    case "PRINTS_OTHER_PO":
      return `Not attached to a purchase order: the bill prints ${note.printedPo}, but this order's PO for ${supplier} is ${note.orderPos[0]}. Attach it from the PO page.`;
    case "SEVERAL_POS":
      return `Not attached to a purchase order: this order has ${note.orderPos.length} purchase orders for ${supplier} (${note.orderPos.join(", ")}). Attach it to the right one from the PO page.`;
    case "NO_LIVE_PO":
      return "Not attached to a purchase order: this order has no purchase order from this bill's supplier (a cancelled one does not count). Attach it from the PO page once there is one.";
    case "VENDOR_NOT_LINKED":
      return "Not attached to a purchase order: this bill is not linked to a vendor, so its order's purchase order cannot be found. Link the vendor, or attach it from the PO page.";
    default:
      return null;
  }
}
